/*
 * Copyright (c) ${year}. Sayari LLC
 */


import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {RegistrationModel} from './models/registration.model';
import {environment} from '../environments/environment';

@Injectable()
export class AppService {
    constructor(private httpClient: HttpClient){}
    register(registrationModel: RegistrationModel) {
        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/json')
            .append('Accept', 'application/json');

        const options = {
            headers: headers,
            observe: 'response' as 'body' // 'observe response' returns the full response (i.e status, body, headers etc)
        };
        return this.httpClient.post<any>(environment.apiUrl + '/v1/venues/register', registrationModel, options);
    }
}